import axiosInstance from './axiosInstance';

const API_URL = process.env.REACT_APP_API_URL;

// GET all PlanningTypes
export const getPlanningType = async () => {
  try {
    const response = await axiosInstance.get(`${API_URL}/planning-types`);
    return response.data;
  } catch (error) {
    console.error("Error fetching PlanningTypes:", error.response?.data || error);
    throw error;
  }
};

// GET a single PlanningType
export const getPlanningTypeById = async (id) => {
  try {
    const response = await axiosInstance.get(`${API_URL}/planning-types/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching PlanningType:", error.response?.data || error);
    throw error;
  }
};

// CREATE a new PlanningType
export const createPlanningType = async (PlanningTypeData) => {
  try {
    const response = await axiosInstance.post(`${API_URL}/planning-types`, PlanningTypeData);
    return response.data;
  } catch (error) {
    console.error("Error creating PlanningType:", error.response?.data || error);
    throw error;
  }
};

// UPDATE an existing PlanningType
export const updatePlanningType = async (id, PlanningTypeData) => {
  try {
    const response = await axiosInstance.put(`${API_URL}/planning-types/${id}`, PlanningTypeData);
    return response.data;
  } catch (error) {
    console.error("Error updating PlanningType:", error.response?.data || error);
    throw error;
  }
};

// DELETE a PlanningType
export const deletePlanningType = async (id) => {
  try {
    const response = await axiosInstance.delete(`${API_URL}/planning-types/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error deleting PlanningType:", error.response?.data || error);
    throw error;
  }
};
